import { render, staticRenderFns } from "./SurveyPreview.vue?vue&type=template&id=6647d9c4&scoped=true&"
import script from "./SurveyPreview.vue?vue&type=script&lang=ts&"
export * from "./SurveyPreview.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyPreview.vue?vue&type=style&index=0&id=6647d9c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6647d9c4",
  null
  
)

export default component.exports